export enum ModalSize {
  SMALL = 'small',
  SMALL_NARROW = 'small_narrow',
  MEDIUM = 'medium',
  MEDIUM_AUTO = 'medium_auto',
  LARGE = 'large',
  FULL = 'full',
  AUTO = 'auto',
}
